import { IOpening, IOptionsApplied, IPivotChunkIndex } from "../domain/PivotDS";

export default abstract class IOnMessageResponseInternal {
  public abstract onApplyOptions(result: IOptionsApplied): void;
  public abstract onToggleCellOpening(result: IOpening): void;
  public abstract onGetPivotChunk(result: IPivotChunkIndex): void;
}
